import apiClient from '../api/api'
import { Survey, SurveyType } from '@/interfaces/survey'

export const surveyApi = {
  // Get all surveys
  getSurveys: async (type: SurveyType): Promise<Survey> => {
    const response = await apiClient.get<Survey>(`/surveys/type/${type}`)
    return response.data
  },
}
